<template>
  <div>
    <div class="form-group-style">
      <h1 class="title">我的个人资料</h1>
          <el-form class="form-container" :model="userInfo" :rules="userRules" ref="userInfoForm">
            <div class="form-item">
              <div class="form-label">
                <span class="label">姓名</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item prop="name">
                  <el-input
                    placeholder="请输入姓名"
                    class="input-control"
                    v-model="user_info.name"
                    disabled="disabled"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">用户名</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="account">
                  <el-input
                    placeholder="请输入用户名"
                    class="input-control"
                    v-model="user_info.account"
                    disabled="disabled"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">旧密码</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="olPassword">
                  <el-input
                    placeholder="请输入旧密码"
                    class="input-control"
                    v-model="userInfo.olPassword"
                    type="password"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">新密码</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="password">
                  <el-input
                    placeholder="请输入新密码"
                    class="input-control"
                    v-model="userInfo.password"
                    type="password"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">确认密码</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="confirmPassword">
                  <el-input
                    placeholder="请输入确认密码"
                    class="input-control"
                    v-model="userInfo.confirmPassword"
                    type="password"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">角色</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label>
                  <el-input
                    placeholder="请输入角色"
                    class="input-control"
                    v-model="roleName"
                    disabled="disabled"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">站点权限</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label>
                  <el-input
                    type="textarea"
                    placeholder="请输入站点权限"
                    class="input-control"
                    v-model="sites"
                    disabled="disabled"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-button">
              <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
              <el-button type="info" plain @click="toWelcome()">取 消</el-button>
            </div>
          </el-form>
    </div>
  </div>
</template>
<script>
import {
  validateEmpty,
  validatePassword,
  validateNumber
} from "@/utils/validate";
import { mapGetters } from "vuex";
import { getUser } from "@/utils/auth";
import {getUserInfo} from '@/utils/auth'
import { getRoleDetail, putPassword } from "@/service/user";
import { getSiteByIds } from "@/service/site";
import { fetchPut } from "@/utils/request";
export default {
  name: "UserInfo",
  data() {
    return {
      userInfo: {
        olPassword: "",
        password: "",
        confirmPassword: ""
      },
      roleName: "",
      sites: "",
      userRules: {
        olPassword: [
          { validator: validatePassword, result: "密码", trigger: "blur" }
        ],
        password: [
          { validator: validatePassword, result: "密码", trigger: "blur" }
        ],
        confirmPassword: [
          {
            validator: validatePassword,
            result: "密码",
            compareData: this.getConfirmValue,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["user_info"])
  },
  mounted: function() {
    this.getRoleName();
    this.getSites();
  },
  methods: {
    toWelcome() {
      this.$router.push("/home/index/welcome");
    },
    /* */
    getRoleName() {
      let user = JSON.parse(getUserInfo());
      getRoleDetail(user.role_id).then(data => {
        this.roleName = data.name;
      });
    },
    getSites() {
      let user = JSON.parse(getUserInfo());
      if (user.sites && user.sites[0] && user.sites[0] == "*") {
        this.sites = "全部站点";
        return;
      }
      getSiteByIds(user.sites.join("_")).then(data => {
        let rel = [];
        for (let i in data) {
          rel.push(data[i].name);
        }
        this.sites = rel.join(",");
      });
    },
    getConfirmValue() {
      return this.userInfo.password;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let query = {
            password_old: this.userInfo.olPassword,
            password_new1: this.userInfo.password,
            password_new2: this.userInfo.confirmPassword
          };
          putPassword(query)
            .then(data => {
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 3 * 1000
              });
              this.$store.dispatch("user/logout").then(() => {
                this.$router.push("/login");
              });
            })
            .catch(err => {
              const message = err.context ? err.context[0] : err.message;
              this.$message({
                message: message || "修改失败",
                type: "error",
                duration: 3 * 1000
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>